import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import NewsPage from '../../component/showcase/NewsPage'
import { Button, Divider, message } from 'antd'
import { getArtistMediaPublic, postArtistMedia } from '../../api/artistMedias'
import Title from 'antd/es/typography/Title'
import { validateMessages } from '../../app/util'
import NewsAddForm from '../../component/showcase/NewsAddForm'
import { uploadAvatar } from '../../api/amazonS3'
import BrowserBorder from '../../component/showcase/BrowserBorder'
import { convertToRaw, EditorState } from 'draft-js'
import { convertFromHTML } from 'draft-convert'
import HttpError from '../../component/base/HttpError'
import ShowcasePreviewLayout from '../../component/showcase/ShowcasePreviewLayout'
import { getArtistProfilePublic } from '../../api/artists'

@connect((state) => ({
  //decorator, gives component access to the state
  siderWidth: state.style.siderWidth,
  id: state.user.info.id,
  userId: state.user.info.userId,
  artistId: state.user.info.artistId,
  email: state.user.info.email,
  artistName: state.user.info.artistName
}))
class News extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      profile: null,
      items: [],
      modalIsVisible: false,
      modalEditId: null,
      bodyRaw: null,
      changedMedia: null
    }
    this.artistId = this.props.artistId
  }

  async componentDidMount() {
    this.IS_MOUNT = true
    const profileRes = await getArtistProfilePublic(this.artistId)
    if (profileRes.status === 404) {
      return
    }
    if (this.IS_MOUNT) {
      this.setState({
        profile: profileRes.data
      })
    }
    const mediaRes = await getArtistMediaPublic(this.props.artistId)
    if (mediaRes.status === 404) {
      return
    }
    if (this.IS_MOUNT) {
      this.setState({
        items: mediaRes.data.results
      })
    }
  }

  componentWillUnmount() {
    this.IS_MOUNT = false
  }

  addMediaHandler = () => {
    const currYear = new Date().getFullYear()
    const blank = {
      title: '',
      year: currYear
    }
    this.setState({
      modalIsVisible: true,
      modalEditId: null,
      changedMedia: blank
    })
  }

  getRawEditorData(data) {
    if (!data) return null
    const editorState = EditorState.createWithContent(convertFromHTML(data))
    const body = convertToRaw(editorState.getCurrentContent())
    return JSON.stringify(body)
  }

  handleCancel = () => {
    //cancelling the modal form for add/edit
    this.setState({
      modalIsVisible: false,
      changedMedia: null
    })
  }

  onSubmit = (editId, values) => {
    const { title, subtitle, description, images, location, year, start_date, end_date, start_time, end_time, link } = values
    const param = {
      artist_id: this.props.artistId,
      title,
      subtitle: subtitle,
      body: description,
      images: JSON.stringify(
        images?.map((image) => ({
          name: image.name,
          url: image.response.url
        })) ?? []
      ),
      location,
      year,
      link,
      start_date,
      end_date,
      start_time,
      end_time
    }
    const updateItemsState = () => {
      const restItem = this.state.items.filter((item) => item.id !== editId)
      restItem.push({
        id: editId,
        ...values
      })
      this.setState({
        items: restItem
      })
    }

    if (!editId) {
      let request
      request = postArtistMedia(param)
      request
        .then(() => {
          message.success('Added successfully').then(() => {})
        })
        .catch((error) => {
          HttpError(error)
        })
    } else {
      // let request;
      // request = putArtistMedia(editId, param);
      // request
      //     .then(() => {
      //         message.success("Edited successfully").then(() => {});
      //     })
      //     .catch((error) => {
      //        HttpError(error)
      //     });
      updateItemsState()
    }
    this.setState({
      modalIsVisible: false,
      changedMedia: null
    })
  }

  onUpdateClick = (id) => {
    const item = this.state.items.filter((item) => {
      return item.id === id
    })
    if (item.length > 0) {
      this.setState({
        modalIsVisible: true,
        modalEditId: id,
        changedMedia: item[0],
        descriptionRaw: this.getRawEditorData(item[0].body)
      })
    }
  }

  onDeleteClick = (id) => {
    console.log(id)
  }

  customRequest = (options) => {
    //this occurs on upload, not submit
    const { onError, onSuccess, file, onProgress } = options
    uploadAvatar(this.props.email, file, onSuccess, onError, onProgress)
  }

  render() {
    return (
      <ShowcasePreviewLayout {...this.props}>
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between' }}>
          <div>
            <Title style={{ marginBottom: 0 }}>News page</Title>
          </div>
          <div>
            <Button
              type='primary'
              onClick={this.addMediaHandler}
              style={{ marginLeft: 'auto', marginRight: 'auto', display: 'block' }}
              block
            >
              Add News
            </Button>
          </div>
        </div>
        <div>
          List your previous collaborations, exhibitions, publications, and recent news here.{' '}
          <a style={{ color: 'black', textDecoration: 'underline' }} href={'https://revart.co/sam/faqs/2.-Manage+The+Showcase'}>
            Learn More
          </a>
          .
        </div>
        <Divider />
        <NewsAddForm
          visible={this.state.modalIsVisible}
          editId={this.state.modalEditId}
          validateMessages={validateMessages}
          toLoad={this.state.bodyRaw}
          onSubmit={this.onSubmit}
          onCancel={this.handleCancel}
          media={this.state.changedMedia}
          customRequest={this.customRequest}
        />
        <BrowserBorder {...this.props}>
          <NewsPage
            {...this.props}
            profile={this.state.profile}
            items={this.state.items}
            onUpdateClick={this.onUpdateClick}
            onDeleteClick={this.onDeleteClick}
          />
        </BrowserBorder>
      </ShowcasePreviewLayout>
    )
  }
}

export default withRouter(News)
